import axios from 'axios';

const updateSupraLockboxGrantees = async (
  deviceSerialNumber: number,
  lockboxId: string,
  userIds: string[],
) => {
  await axios.post(`/supra/update_grantees/${lockboxId}`, {
    deviceSerialNumber,
    lockboxId,
    userIds,
  });
};

export default updateSupraLockboxGrantees;
